"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 40 40",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
        fill: "#016b6a"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "m16.562 27.951-.016.02-6.278-6.28 2.757-2.755 3.521 3.51 10.422-10.419 2.764 2.766-13.17 13.158Zm3.436-23.534c-8.255 0-14.995 6.426-15.529 14.55-.025.343-.052.682-.052 1.031 0 5.902 3.284 11.035 8.12 13.682a15.554 15.554 0 0 0 7.461 1.903c8.604 0 15.585-6.983 15.585-15.585 0-8.606-6.981-15.581-15.585-15.581Z",
        fill: "#fff"
      })]
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};